import React from 'react';
import { Skeleton as MuiSkeleton, SkeletonProps as MuiSkeletonProps } from '@mui/material';
import { StyledSkeleton } from './Skeleton.style';

export interface SkeletonProps extends MuiSkeletonProps {
  /**
   * The variant of the skeleton
   */
  variant?: 'text' | 'rectangular' | 'rounded' | 'circular';
  /**
   * The animation of the skeleton
   */
  animation?: 'pulse' | 'wave' | false;
  /**
   * The width of the skeleton
   */
  width?: string | number;
  /**
   * The height of the skeleton
   */
  height?: string | number;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'text',
  animation = 'pulse',
  width,
  height,
  ...props
}) => {
  return (
    <StyledSkeleton
      variant={variant}
      animation={animation}
      width={width}
      height={height}
      {...props}
    />
  );
}; 